import styled from 'styled-components'

import { outlineStyles } from 'components/Editor/styled/Outline'
import type { MediaStyles } from 'components/MediaPlayer/types'

export const VolumeSliderWrapper = styled.div`
  position: relative;
  display: flex;
  gap: 4px;
`

export const VolumeSliderInputWrapper = styled.div`
  position: relative;
  display: flex;
  margin-right: 8px;
`

export const VolumeSliderFilled = styled.div<{
  $styles?: Partial<Record<MediaStyles, React.CSSProperties>>
  $value: number // percents
}>`
  position: absolute;
  height: 100%;
  background-color: ${({ $styles }) =>
    $styles?.sliderFilled?.backgroundColor || 'var(--color-primary-default)'};
  width: ${({ $value }) => `${$value}%`};
`

export const VolumeSliderInput = styled.input`
  width: 88px;
  background: transparent;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;

  &::-webkit-slider-thumb {
    position: relative;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    box-shadow: var(--box-shadow-default);
    background: var(--color-background-main);
    z-index: 1;
    -webkit-appearance: none;
  }

  &:focus-visible::-webkit-slider-thumb {
    ${outlineStyles}
  }
`

export const VolumeSliderTrack = styled.div<{
  $styles?: Partial<Record<MediaStyles, React.CSSProperties>>
}>`
  position: absolute;
  width: 88px;
  height: 4px;
  top: 50%;
  border-radius: 2px;
  transform: translateY(-50%);
  pointer-events: none;
  overflow: hidden;
  background-color: ${({ $styles }) =>
    $styles?.slider?.backgroundColor || 'var(--color-background-secondary)'};

  &:has(+ ${VolumeSliderInput}:focus-visible) {
    ${outlineStyles}
  }
`
